/** A Mapbox raster tile template for a WMS layer, reprojected server-side to Web Mercator. */
export function wmsTileUrl(baseUrl: string, layer: string): string {
  const params = new URLSearchParams({
    SERVICE: "WMS",
    REQUEST: "GetMap",
    VERSION: "1.1.1",
    LAYERS: layer,
    STYLES: "",
    SRS: "EPSG:3857",
    WIDTH: "256",
    HEIGHT: "256",
    FORMAT: "image/png",
    TRANSPARENT: "true",
  });
  const separator = baseUrl.includes("?") ? "&" : "?";
  // Mapbox substitutes the placeholder itself, so it must stay out of URLSearchParams' encoding.
  return `${baseUrl}${separator}${params}&BBOX={bbox-epsg-3857}`;
}

/** WFS GetFeature as GeoJSON in EPSG:25832; `useWFSViewportData` appends the viewport BBOX. */
export function wfsUrl(baseUrl: string, typeName: string): string {
  return (
    `${baseUrl}?SERVICE=WFS&REQUEST=GetFeature` +
    `&TYPENAMES=${typeName}&VERSION=2.0.0&OUTPUTFORMAT=application/json&SRSNAME=EPSG:25832`
  );
}

export function wmsLegendUrl(baseUrl: string, layer: string): string {
  const url = new URL(baseUrl);
  for (const [key, value] of Object.entries({
    SERVICE: "WMS",
    REQUEST: "GetLegendGraphic",
    VERSION: "1.1.1",
    LAYER: layer,
    FORMAT: "image/png",
    WIDTH: "20",
    HEIGHT: "20",
  }))
    url.searchParams.set(key, value);
  return url.toString();
}
